import React from "react";
import { FaUsers, FaClipboardList, FaRocket } from "react-icons/fa";

const stats = [
  {
    icon: <FaUsers />,
    title: "SNS및 전체 회원수",
    value: "35,645",
  },
  {
    icon: <FaClipboardList />,
    title: "오늘 완료된 주문",
    value: "2,423",
  },
  {
    icon: <FaRocket />,
    title: "누적 완료된 주문",
    value: "67,751",
  },
];

const DashboardSummary = () => {
  return (
    <div className="dashboard-summary-stats-container">
      {stats.map((stat, index) => (
        <div key={index} className="dashboard-stat-item">
          <p className="dashboard-stat-title">{stat.title}</p>
          <div className="dashboard-stat-value-wrapper">
            <span className="dashboard-stat-icon">{stat.icon}</span>
            <span className="dashboard-stat-value">{stat.value}</span>
          </div>
        </div>
      ))}
    </div>
  );
};

export default DashboardSummary;
